import styled from 'styled-components';
import { Input } from './Input';
import { Button, Icon, Modal } from '@successmode-ktp/kui';
import { useState } from 'react';
import { IMG_SWIFTCODE } from '@repo/assets';

type Props = {
  register: any;
  disabled?: boolean;
  errors: any;
};

export const SwiftCode = ({ register, disabled, errors }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Wrapper>
        <Input
          {...register('swiftCode', {
            required: 'This is a required item.',
            pattern: {
              value: /^[a-zA-Z0-9][a-zA-Z0-9\s]*$/,
              message: 'Please enter only English and numbers.',
            },
          })}
          label='SWIFT Code'
          isRequired
          placeholder='8 to 11 digits of characters'
          disabled={disabled}
          error={errors?.swiftCode}
        />
        <Question type='button' onClick={() => setIsOpen(true)}>
          <Icon.QuestionFilled fillColor='#9FA1A7' />
        </Question>
      </Wrapper>

      <Modal
        isOpen={isOpen}
        hasBackdrop
        onClickBackdrop={() => setIsOpen(false)}
      >
        <Modal.Header>
          <Title>What is Swift Code?</Title>
        </Modal.Header>
        <Contents>
          <Description>
            A SWIFT code is a standard format used when making international
            transfers between banks and financial institutions.
          </Description>
          <img src={IMG_SWIFTCODE} alt='' width={250} />
          <DescriptionStrong>
            You can find out the Swift Code by contacting the bank where you
            wish to receive the transfer.
          </DescriptionStrong>
        </Contents>
        <Modal.Footer>
          <Button type='button' size='sm' onClick={() => setIsOpen(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const Wrapper = styled.div`
  position: relative;
  margin-top: 10px;
`;

const Title = styled.h6`
  width: 100%;
  text-align: center;
  margin-bottom: 4px;
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  max-width: 270px;
`;

const Description = styled.p`
  color: var(--KTP-Grayscale-80, var(--KTP-Color-Mono-80, #3a3b3e));
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.24px;
  text-align: center;
`;

const DescriptionStrong = styled.strong`
  color: var(--KTP-Grayscale-Gray_02, #111);
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.28px;
  text-align: center;
`;

const Question = styled.button`
  position: absolute;
  top: 2px;
  right: 0;
`;
